const CreditorsIndex = () => import('./outgoing/index.vue');
const CreditorView = () => import('./outgoing/view.vue');

const DebtorsIndex = () => import('./incoming/index.vue');
const DebtorView = () => import('./incoming/view.vue');

const SellingPriceListIndex = () => import('./price-lists/index.vue');
const SpList = () => import('./price-lists/_pages/manage.vue');

export default [
    {
        path: '/list/report/sp',
        component: SellingPriceListIndex
    },
    {
        path: '/list/report/sp/:id',
        component: SpList
    },
    {
        path: '/list/report/creditors',
        name: 'Creditors',
        component: CreditorsIndex
    },
    {
        path: '/report/creditors/:id',
        name: 'CreditorsView',
        component: CreditorView
    },
    {
        path: '/list/report/debtors',
        name: 'Debtors',
        component: DebtorsIndex
    },
    {
        path: '/report/debtors/:id',
        name: 'DebtorView',
        component: DebtorView
    },
]